// extracted by mini-css-extract-plugin
export var localeSelector = "_5z-0";